const addDefaultDeviceParameters = values => {
  values.message_format.msg_length = 24;
  if (["temperature", "temphumid", "temphumidco2"].includes(values.message_format.type)) {
    values.message_format.measurement_count = 4;
    values.meter_type = values.message_format.type;
  }
  // M12345678 -> mirroring device for th01nbiot devices
  if (["temphumid"].includes(values.message_format.type) && values.id.match(/^N\d{7}$/)) {
    values.message_format.measurement_count = 1;
    values.message_format.msg_length = 6;
    values.meter_type = values.message_format.type;
  }
  if (["th01nbiot"].includes(values.message_format.type)) {
    values.message_format.measurement_count = 1;
    values.message_format.msg_length = 32;
    values.meter_type = values.message_format.type;
  }
  if (["tilt"].includes(values.message_format.type)) {
    values.message_format.measurement_count = 1;
    values.message_format.msg_length = 12; // 6 bytes
    values.meter_type = values.message_format.type;
  }
  return values;
};

export default addDefaultDeviceParameters;
